import type { SessionFields } from "@/Modules/Models/Domain/ClinicalHistory";
import type { SessionFieldsApi } from "@/Modules/Models/Api/ClinicalHistory";
import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";

const SessionFieldsTransformer: TransformerExtended<SessionFields, SessionFieldsApi> = {
  ...DefaultTransformerGenerator<SessionFields, SessionFieldsApi>(),

  toDomain(input: SessionFieldsApi): SessionFields {
    return camel<SessionFieldsApi, SessionFields>(input);
  },
};

export type SessionFieldsTransformerType = TransformerExtended<SessionFields, SessionFieldsApi>;

export default SessionFieldsTransformer;
